import type { EmptyObject } from '@/utils/primitives'
import type { NodeAttributes } from '../tiptap-helpers'

import { Node } from '@tiptap/core'
import { ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react'

import {
  MENTIONSNODE_NAME,
  MENTIONSNODE_TAG,
  MENTIONSNODE_TAG_LEGACY,
} from './mentions.config'

import { MentionNodeViewLive } from './MentionNodeView'
import { createMentionsSuggestion } from './MentionsSuggestion'

type MentionNodeOptions = EmptyObject

export type MentionNodeAttributes = {
  mentionId: string
  fallbackName: string
}

export const MentionNode = Node.create<
  MentionNodeOptions,
  MentionNodeAttributes
>({
  name: MENTIONSNODE_NAME,
  group: 'inline',
  atom: true,
  inline: true,
  selectable: false,
  defining: true,

  addAttributes() {
    return {
      mentionId: {
        parseHTML: (element) => element.getAttribute('data-mention-id'),
        renderHTML: (attributes) => {
          if (!attributes.mentionId) return {}

          return { 'data-mention-id': attributes.mentionId }
        },
      },
      // Fallback name to use after the mention was deleted
      fallbackName: {
        parseHTML: (element) => element.getAttribute('data-fallback-name'),
        renderHTML: (attributes) => {
          if (!attributes.fallbackName) return {}

          return { 'data-fallback-name': attributes.fallbackName }
        },
      },
    } satisfies NodeAttributes<MentionNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: MENTIONSNODE_TAG },
      { tag: MENTIONSNODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [MENTIONSNODE_TAG, mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(MentionNodeViewLive)
  },

  addProseMirrorPlugins() {
    return [
      createMentionsSuggestion({
        name: this.name,
        editor: this.editor,
      }),
    ]
  },
})
